import axios from "../../axios/axios-root";

export const pegaSessao = ({ commit }, payload) => {
    commit("setLoading", true);

    return axios
    .post("publico/controller/listarSessao.php")
    .then(resp => {
        commit("setLoading", false)

        if (resp.data.status == false) window.location.href = "/login"
        if (resp.data.pcenso == "0") {
            var r = confirm("Você não tem permissão para acessar esse sistema");
            if (r == true || r == false) window.location.href = "/painel"
            return
        }

        commit("setUsuario", resp.data)
        if (
            resp.data.cnes == '5347149' ||
            resp.data.cnes == '7940173' ||
            resp.data.cnes == '7099428' ||
            resp.data.cnes == '0153990' ||
            resp.data.cnes == '3704432' 
        ) commit("setUsuarioGestao", true)
    })
    .catch(error => {
        commit("setLoading", false);
    });

};

export const validaSessao = () => {
    return axios
    .post("publico/controller/listarSessao.php")
};